import { render, staticRenderFns } from "./toolbarLoginLogout.vue?vue&type=template&id=3b53cbc1&"
import script from "./toolbarLoginLogout.vue?vue&type=script&lang=js&"
export * from "./toolbarLoginLogout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports